var VueAxios = {
  vm: {},
  // eslint-disable-next-line no-unused-vars
  install: function install(Vue) {
    var router = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var instance = arguments.length > 2 ? arguments[2] : undefined;

    if (this.installed) {
      return;
    }

    this.installed = true;

    if (!instance) {
      // eslint-disable-next-line no-console
      console.error('You have to install axios');
      return;
    }

    Vue.axios = instance;
    Object.defineProperties(Vue.prototype, {
      axios: {
        get: function get() {
          return instance;
        }
      },
      $http: {
        get: function get() {
          return instance;
        }
      }
    });
  }
};
export { VueAxios // eslint-disable-next-line no-undef
//instance as axios
};